import { FrameStore, ModuleBase } from "@/modules/base";
import { CreateElement } from "vue";
import { Component, Mixins, Prop, Vue } from 'vue-property-decorator';
import { Layer2Component } from '@/stellar-globe-components';
import { HipparcosCatalogLayer } from '@hscmap/stellar-globe';

@Component
export class HipparcosCatalogLayerModule extends Mixins(ModuleBase) {
  get outlet() {
    return {
      overlayLayer: OverlayLayer,
    }
  }

  frameStore() {
    return {
      show: true,
    }
  }
}

@Component
class OverlayLayer extends Vue {
  @Prop({ required: true })
  frameStore!: FrameStore<typeof HipparcosCatalogLayerModule>

  render(h: CreateElement) {
    return this.frameStore.show ? h(Layer2Component(HipparcosCatalogLayer)) : undefined
  }
}
